module.exports = __webpack_public_path__ + "assets/avatar_van.b15f13df.svg";